import { createVNode as _createVNode, resolveComponent as _resolveComponent, withKeys as _withKeys, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { id: "receive-item" }
const _hoisted_2 = { class: "flex flex-col lg:flex-row md:flex-row items-center justify-start md:justify-between lg:justify-between" }
const _hoisted_3 = /*#__PURE__*/_createVNode("div", { class: "flex items-center self-start mb-3 lg:mb-0 md:mb-0" }, [
  /*#__PURE__*/_createVNode("h6", { class: "mr-3 font-normal text-left" }, "Daftar Barang Yang Anda Terima")
], -1)
const _hoisted_4 = { class: "w-full lg:w-auto md:w-auto" }
const _hoisted_5 = { class: "flex items-center mb-2 lg:flex-row flex-col  lg:mb-4 md:mb-4" }
const _hoisted_6 = { class: "flex" }
const _hoisted_7 = { class: "flex items-center mr-2 w-1/2 md:w-auto lg:w-auto lg:mr-3 md:mr-3" }
const _hoisted_8 = /*#__PURE__*/_createVNode("h6", {
  class: "font-normal md:text-base lg:text-base text-sm w-1/2 lg:w-auto md:w-auto",
  style: {"color":"#EF5350"}
}, "Agent Asal :  ", -1)
const _hoisted_9 = { class: "font-normal md:text-base lg:text-base text-sm mr-1 cursor-pointer truncate color-blue-grey" }
const _hoisted_10 = /*#__PURE__*/_createVNode("i", { class: "pi pi-sort-down text-xs lg:mt-1 md:mt-1 mt-0 cursor-pointer color-blue-grey" }, null, -1)
const _hoisted_11 = { class: "flex items-center w-1/2 md:w-auto lg:w-auto" }
const _hoisted_12 = /*#__PURE__*/_createVNode("h6", { class: "font-normal md:text-base lg:text-base text-sm w-1/2 lg:w-auto md:w-auto color-green-darken-1" }, "Ketibaan :  ", -1)
const _hoisted_13 = { class: "font-normal md:text-base lg:text-base text-sm mr-1 cursor-pointer truncate color-blue-grey" }
const _hoisted_14 = /*#__PURE__*/_createVNode("i", { class: "pi pi-sort-down text-xs lg:mt-1 md:mt-1 mt-0 cursor-pointer color-blue-grey" }, null, -1)
const _hoisted_15 = { class: "flex items-center w-1/2 md:w-auto lg:w-auto lg:ml-3 md:ml-3" }
const _hoisted_16 = { class: "flex  lg:flex-row flex-col lg:w-auto md:w-auto" }
const _hoisted_17 = {
  key: 0,
  class: "flex flex-col"
}
const _hoisted_18 = {
  key: 1,
  class: "py-4 px-5 text-center color-blue-grey"
}
const _hoisted_19 = {
  class: "overflow-y-auto small-scroll-y px-2",
  style: {"max-height":"8rem"}
}
const _hoisted_20 = { class: "btn-action w-full flex justify-end mt-5 px-4 pb-4" }
const _hoisted_21 = /*#__PURE__*/_createTextVNode("Clear Filter")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_InputIconRightGrey = _resolveComponent("InputIconRightGrey")
  const _component_SelectButton = _resolveComponent("SelectButton")
  const _component_ItemReceiptCard = _resolveComponent("ItemReceiptCard")
  const _component_router_link = _resolveComponent("router-link")
  const _component_Paginator = _resolveComponent("Paginator")
  const _component_Card = _resolveComponent("Card")
  const _component_OverlayPanel = _resolveComponent("OverlayPanel")
  const _component_Calendar = _resolveComponent("Calendar")
  const _component_Button = _resolveComponent("Button")

  return (_openBlock(), _createBlock("section", _hoisted_1, [
    _createVNode(_component_Card, null, {
      title: _withCtx(() => [
        _createVNode("div", _hoisted_2, [
          _hoisted_3,
          _createVNode("div", _hoisted_4, [
            _createVNode(_component_InputIconRightGrey, {
              modelValue: _ctx.inputSearch,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.inputSearch = $event)),
              class: "w-full lg:w-auto md:w-auto",
              placeholder: "Cari Resi, Penerimaan, Dll...",
              onKeyup: _cache[2] || (_cache[2] = _withKeys(($event: any) => (_ctx.searchData(_ctx.inputSearch)), ["enter"])),
              type: _ctx.$enumBase.input.text,
              icon: _ctx.$icon.svg.searchEva
            }, null, 8, ["modelValue", "type", "icon"])
          ])
        ])
      ]),
      content: _withCtx(() => [
        _createVNode("div", _hoisted_5, [
          _createVNode("div", _hoisted_6, [
            _createVNode("div", _hoisted_7, [
              _hoisted_8,
              _createVNode("div", {
                class: "flex items-center w-1/2 lg:w-auto md:w-auto",
                onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.showDropdownFromAgent($event)))
              }, [
                _createVNode("h6", _hoisted_9, _toDisplayString(_ctx.filters.fromAgentId.label), 1),
                _hoisted_10
              ])
            ]),
            _createVNode("div", _hoisted_11, [
              _hoisted_12,
              _createVNode("div", {
                class: "flex items-center w-1/2 lg:w-auto md:w-auto",
                onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.showDropdownArrival($event)))
              }, [
                _createVNode("h6", _hoisted_13, _toDisplayString((_ctx.filters.dateFilter) ? _ctx.moment(_ctx.filters.dateFilter).format('DD MMM YYYY') : 'Semua Waktu'), 1),
                _hoisted_14
              ])
            ])
          ]),
          _createVNode("div", _hoisted_15, [
            _createVNode("div", _hoisted_16, [
              _createVNode(_component_SelectButton, {
                class: "selectScheduleBus scheduleBusSmall",
                modelValue: _ctx.selectValue,
                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (_ctx.selectValue = $event)),
                options: _ctx.selectOption,
                optionValue: "value",
                optionLabel: "name",
                multiple: ""
              }, null, 8, ["modelValue", "options"])
            ])
          ])
        ]),
        (_ctx.data.length > 0)
          ? (_openBlock(), _createBlock("div", _hoisted_17, [
              (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.data, (item, index) => {
                return (_openBlock(), _createBlock(_component_router_link, {
                  class: "cursor-pointer w-full mb-4",
                  key: 'item-' + index,
                  to: {name: 'transaksi-barang-diterima-detail', params: { id: item.Id }}
                }, {
                  default: _withCtx(() => [
                    item
                      ? (_openBlock(), _createBlock(_component_ItemReceiptCard, {
                          key: 0,
                          data: item,
                          class: "w-full"
                        }, null, 8, ["data"]))
                      : _createCommentVNode("", true)
                  ]),
                  _: 2
                }, 1032, ["to"]))
              }), 128)),
              (_ctx.data.length > 0)
                ? (_openBlock(), _createBlock(_component_Paginator, {
                    key: 0,
                    rows: _ctx.filters.top,
                    totalRecords: _ctx.filters.totalRecords,
                    onPage: _ctx.onPage
                  }, null, 8, ["rows", "totalRecords", "onPage"]))
                : _createCommentVNode("", true)
            ]))
          : (_openBlock(), _createBlock("p", _hoisted_18, "Penerimaan Barang Tidak Ditemukan"))
      ]),
      _: 1
    }),
    _createVNode(_component_OverlayPanel, {
      ref: "agentOp",
      class: "p-4"
    }, {
      default: _withCtx(() => [
        _createVNode("div", _hoisted_19, [
          (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.listAgent, (data, index) => {
            return (_openBlock(), _createBlock("ul", {
              class: ["mb-2 listFilter cursor-pointer", data.value === _ctx.filters.fromAgentId.value ? 'color-primary' : ''],
              onClick: ($event: any) => (_ctx.selectedAgent($event, data)),
              key: 'agent-' + index
            }, [
              _createVNode("li", null, _toDisplayString(data.label), 1)
            ], 10, ["onClick"]))
          }), 128))
        ])
      ]),
      _: 1
    }, 512),
    _createVNode(_component_OverlayPanel, { ref: "arrivalOp" }, {
      default: _withCtx(() => [
        _createVNode(_component_Calendar, {
          modelValue: _ctx.filters.dateFilter,
          "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (_ctx.filters.dateFilter = $event)),
          inline: true,
          showWeek: true
        }, null, 8, ["modelValue"]),
        _createVNode("div", _hoisted_20, [
          (_ctx.filters.dateFilter)
            ? (_openBlock(), _createBlock(_component_Button, {
                key: 0,
                label: "Filter",
                class: "font-semibold p-button-sm btn-primary px-10 mr-2",
                onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.saveFilterDate($event)))
              }))
            : _createCommentVNode("", true),
          (_ctx.filters.dateFilter)
            ? (_openBlock(), _createBlock(_component_Button, {
                key: 1,
                class: "btn-secondary text-black p-button-sm px-10 py-1",
                onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.clearFilterDate($event)))
              }, {
                default: _withCtx(() => [
                  _hoisted_21
                ]),
                _: 1
              }))
            : _createCommentVNode("", true)
        ])
      ]),
      _: 1
    }, 512)
  ]))
}